import { Fragment } from "react";

import { Col } from "@/components/General/Grid/col.component";
import { TooltipType } from "@/components/General/Tooltip/tooltip.types";
import { AdditionalServiceComponent } from "@/components/Product/AdditionalService/additionalService.component";
import { AdditionalServiceModel } from "@/types/service/shared";
import { formatPrice } from "@/utils/price.utils";

type AdditionalServicesComponentProps = {
    additionalServices: AdditionalServiceModel[];
    additionalServiceTooltip?: TooltipType;
};

const AdditionalServicesComponent = ({
    additionalServices,
    additionalServiceTooltip
}: AdditionalServicesComponentProps) =>
    additionalServices.map((additionalService, index) => (
        <Fragment key={`${additionalService.sku}-${index}`}>
            <Col
                xs={9}
                sm={7}
                className={"offset-3 offset-sm-2"}
            >
                <AdditionalServiceComponent
                    additionalService={additionalService}
                    tooltip={additionalServiceTooltip}
                />
            </Col>
            <Col
                xs={12}
                md={3}
                className={
                    "text-right font-weight-bold h4 m-0 pt-1 pb-3 py-md-0"
                }
            >
                <div>{formatPrice(additionalService.price)}</div>
            </Col>
        </Fragment>
    ));

export { AdditionalServicesComponent };
